import type { IconName } from '#/components/Icon/IconName';

type Args = {
  listingType:
    | 'JOB'
    | 'INTERNSHIP'
    | 'VOLOP'
    | 'EVENT'
    | 'IMPORTED'
    | 'ORG'
    | 'GROUP';
};

export function getListingTypeLabelIcon({ listingType }: Args): IconName {
  switch (listingType) {
    case 'JOB':
    case 'INTERNSHIP':
      return 'sign-path';

    case 'VOLOP':
    case 'IMPORTED':
      return 'hand';

    case 'EVENT':
      return 'star-calendar';

    case 'ORG':
      return 'building';

    case 'GROUP':
      return 'group';
  }
}
